<template>
  <div>
    <loader :loader="sending" />
    <template>
      <patient-information :model="model" />
      <patient-interpretation-appo-info :model="model" />
      <study-background :parameters="model" />

      <interpretation-options :sending="sending" :reported="reported" :withBirads="withBirads"
        :buttonBirads="buttonBirads" :model="model" :modelDialog="modelDialog" @ReportedValue="ReportedValue"
        @validBiradsEmit="validBiradsEmit" />
      <interpretation-interpretations :model="model" :changeTemplateInterpretation="changeTemplateInterpretation"
        :isPDF="isPDF" :downloadViewer="downloadViewer" :downloadZIP="downloadZIP" :viewerOsirix="viewerOsirix"
        :downloadInterpretation="downloadInterpretation" :sending="sending" :reported="reported"
        :validBirads="validBirads" :loadingImages="loadingImages" :listTemplates="listTemplates"
        @seeOrHideViewer="seeOrHideViewer" :images="images" :addImages="addImages" :saveTemplate="saveTemplate"
        :modelDialog="modelDialog" :fillinterpretation="fillinterpretation" :dialogViewer="dialogViewer"
        :closeSliderSaveTemp="closeSliderSaveTemp" :mastography="mastography" :listAllTemplates="listAllTemplates" />
      <v-expand-transition>
        <v-row v-if="dialogViewer" align="center" justify="center" class="d-flex flex-wrap text-center mb-2">
          <v-col class="col-md-2" v-for="(file, index) in images" :key="index" :id="index">
            <v-icon type="button" size="50px" color="error" @click="openPDF(file)">mdi-file-pdf-box</v-icon>
            <h3 style="text-align: center" class="mt-2 mb-2">
              Ver informe {{ index + 1 }}
            </h3>
          </v-col>
        </v-row>
      </v-expand-transition>
      <v-row>
        <v-col v-if="allowCopyPaste">
          <validation-provider v-slot="{ errors }" name="diagnostico" rules="required">
            <vue-editor v-model="interpretation" required :error-messages="errors"
              :disabled="reported || sending"></vue-editor>
          </validation-provider>
        </v-col>
        <v-col v-if="!allowCopyPaste" @click.right.prevent @copy.prevent @paste.prevent ondrop="return false;">
          <validation-provider v-slot="{ errors }" name="diagnostico" rules="required">
            <vue-editor v-model="interpretation" required :error-messages="errors"
              :disabled="reported || sending"></vue-editor>
          </validation-provider>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="8">
              <validation-provider v-slot="{ errors }" name="adjuntar archivos" rules="maxSizeFile">
                <v-file-input v-model="files" placeholder="Seleccione los archivos" label="Adjuntar archivos" multiple
                  show-size counter prepend-icon="mdi-paperclip" :disabled="reported"
                  :error-messages="errors"></v-file-input>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="d-flex flex-nowrap" align="baseline" justify="center">
            <v-col cols="2" class="text-center" v-for="(file, index) in files" :key="index">
              <div class="d-flex flex-column justify-center">
                <div class="d-flex justify-end">
                  <v-btn icon @click="deleteFile(file.name)">
                    <v-icon size="24px" color="error">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-icon style="font-size: 11vh; text-align: center" size="100px" :color="file.type === 'application/pdf' || 'pdf'
                    ? 'error'
                    : 'grey' || file.type === 'image/jpeg' || 'jpeg'
                      ? 'secondary'
                      : 'grey'
                  ">{{
    file.type === "application/pdf" || "pdf"
    ? "mdi-file-pdf-box"
    : "mdi-file" || file.type === "image/jpeg" || "jpeg"
      ? "mdi-image"
      : "mdi-file"
  }}</v-icon>
                <h1 style="font-size: 120%; text-align: center">
                  {{ file.name }}
                </h1>
              </div>
            </v-col>
          </v-row>
          <v-row class="d-flex flex-nowrap" align="baseline" justify="center">
            <v-col cols="2" class="text-center" v-for="(file, index) in addendums" :key="index">
              <div class="d-flex flex-column justify-center">
                <div class="d-flex justify-end">
                  <v-btn icon @click="confirmDeleteAddendum(file)" :disabled="reported">
                    <v-icon size="24px" color="error">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-icon style="font-size: 11vh; text-align: center" size="100px" :color="file.type === 'pdf'
                    ? 'error'
                    : 'grey' || file.type === 'jpeg'
                      ? 'secondary'
                      : 'grey'
                  ">{{
    file.type === "pdf"
    ? "mdi-file-pdf-box"
    : "mdi-file" || file.type === "jpeg"
      ? "mdi-image"
      : "mdi-file"
  }}</v-icon>
                <h1 style="font-size: 120%; text-align: center">
                  {{ file.name }}
                </h1>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <v-dialog v-model="swalDialog" persistent></v-dialog>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientInterpretationAppoInfo from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
import StudyBackground from "@/app/components/interpretation/StudyBackground.vue";
import InterpretationOptions from "@/app/components/interpretation/InterpretationOptions.vue";
import InterpretationInterpretations from "@/app/components/interpretation/InterpretationInterpretations.vue";
import InterpretationReportDialog from "@/app/components/interpretation/InterpretationReportDialog.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import {
  ReportPDFRequest,
  StudyRequest,
  DownloadZipRequest,
  InterpretationHistoryRequest,
} from "@/core/request";
import { InterpretationHistoryService } from "@/app/services";
import { TemplateDialogService } from "@/app/services";
import ConfigurationService from "@/app/services/ConfigurationService";
import { UtilFront } from "@/core/";

import { ValidationProvider } from "vee-validate";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    PatientInformation,
    StudyBackground,
    PatientInterpretationAppoInfo,
    InterpretationOptions,
    InterpretationInterpretations,
    InterpretationReportDialog,
    ValidationProvider,
    VueEditor,
    Loader,
  },
  props: {
    model: Object,
    modelDialog: Object,
    buttonBirads: Boolean,
    saveFilesChanges: Boolean,
    mastography: Boolean,
  },
  data() {
    return {
      files: undefined,
      sending: false,
      invalidSign: true,
      reported: false,
      withBirads: false,
      loadingImages: false,
      validBirads: false,
      dialogViewer: false,
      menu: false,
      listTemplates: [],
      interpretation: "",
      images: [],
      imagesToAdd: [],
      mapping: [],
      addendums: [],
      swalDialog: false,
      fillinterpretation: false,
      closeSliderSaveTemp: false,
      allowCopyPaste: false
    };
  },
  mounted() {
    this.listAllTemplates();
    this.findAllImagesByStudy();
    this.specialCharacter();
    this.setDatafromModel();
    this.findConfigurationCopyPaste();
  },
  watch: {
    saveFilesChanges: function () {
      if (this.saveFilesChanges) {
        this.setFilesToModel();
      }
    },
    interpretation: function () {
      if (this.interpretation == "") {
        this.fillinterpretation = false;
      } else {
        this.fillinterpretation = true;
      }
    },
  },
  methods: {
    findConfigurationCopyPaste() {
      ConfigurationService.findConfigurationCopyPasteInterpretation({idBranchOffice: null}).then((response) => {
        let { data, status } = response;
        this.allowCopyPaste = data?.allowCopyPaste || false;
      }).catch(this.catchError)
        .finally(() => { });
    },
    deleteFile(fileName) {
      let i = this.files.findIndex((index) => index.name === fileName);
      if (i > -1) {
        this.files.splice(i, 1);
      }
    },
    confirmDeleteAddendum(file) {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea eliminar el documento?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.buttonBirads = false;
          this.deleteFileService(file);
        } else {
          this.swalDialog = false;
        }
      });
    },
    setDatafromModel() {
      this.interpretation = this.model.interpretation;
    },
    specialCharacter() {
      let from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";

      for (let i = 0, j = from.length; i < j; i++) {
        this.mapping[from.charAt(i)] = to.charAt(i);
      }
    },
    /**emits */
    ReportedValue(value) {
      this.reported = value;
    },
    seeOrHideViewer(value) {
      this.dialogViewer = value;
    },
    validBiradsEmit(value, biradsSelected) {
      console.log(biradsSelected);
      this.$emit("ActiveButtonSave", value);
      this.validBirads = value;
    },
    /** */
    async setFilesToModel() {
      let filesList = [];
      if (this.files != null && this.files.length != 0) {
        for (let file of this.files) {
          const value = await this.getBase64(file);
          filesList.push(value);
        }
      }
      this.model.filesList = filesList;
      this.model.interpretation = this.interpretation;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        try {
          let reader = new FileReader();
          //for (let file of files) {
          reader = new FileReader();
          let fileByte = [];
          reader.readAsArrayBuffer(file);
          reader.onload = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              let arrayBuffer = evt.target.result,
                array = new Uint8Array(arrayBuffer);
              for (let byte of array) {
                fileByte.push(byte);
              }
            }
            let c = "";
            for (var i = 0, j = file.name.length; i < j; i++) {
              var l = file.name.charAt(i);
              c = c + (l in this.mapping ? this.mapping[l] : l);
            }
            let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");
            let f = {
              bytes: fileByte,
              fileName: te,
              type: file.type,
            };
            //this.filesToSave.push(f);
            resolve(f);
          };
          reader.onerror = function (error) {
            this.$utilFront.notifications(
              "Error al procesar archivo: " + file.name,
              "ERROR"
            );
          };
          //}
          reader.onloadend = (end) => {
            //this.add();
          };
        } catch (e) {
        } finally {
        }
      });
    },
    deleteFileService(item) {
      let data = {
        fileName: item.fileName,
        idInterpretation: this.model.idInterpretation,
      };
      InterpretationHistoryRequest.deleteOneAddendum(data).then((res) => {
        if (res.data.status == "OK" && res.data.data == true) {
          this.$utilFront.notifications(
            "Archivo eliminado correctamente",
            "SUCCESS"
          );
          this.dialogViewer = false;
          this.addendums = this.addendums.filter((a) => {
            return a.fileName !== item.fileName;
          });
        } else if (res.data.code == 401) {
        } else if (typeof res.data.data == false) {
          this.$utilFront.notifications(
            "Error al eliminar el archivo",
            "ERROR"
          );
        } else {
        }
      });
    },
    findAllImagesByStudy() {
      let data = {
        idStudy: this.model.idStudy,
      };
      let params = {
        idInterpretation: this.model.idInterpretation,
      };
      this.loadingImages = true;
      StudyRequest.findAllImagesByStudy(data)
        .then((res) => {
          let data = res.data;
          this.images = data.data;
        })
        .finally(() => {
          this.loadingImages = false;
        });
      InterpretationHistoryService.getAddendums(params)
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200 && typeof data === "object") {
            this.addendums = data;
            this.addendums.map((addendum) => {
              addendum.name = addendum.fileName;
            });
          }
        })
        .catch(() => {
          this.catchError();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    listAllTemplates() {
      this.listTemplates = [];
      let params = {
        // idPerson: this.$utilFront.getIdPerson(),
        idModality: this.model.idModality,
      };
      TemplateDialogService.listAllTemplates(params)
        .then((res) => {
          let { data, status } = res;
          if (Array.isArray(data)) {
            this.listAllTemplatesToTable = data;
            this.listTemplates = data.map((obj) => {
              return {
                value: obj,
                text: obj.name + " (" + obj.idTemplateInterpretation + ")",
              };
            });
          } else {
            this.$utilFront.notifications(
              "Error al listar las plantillas.",
              "ERROR"
            );
          }
        })
        .catch(this.catchError)
        .finally(() => { });
    },
    saveTemplate() {
      this.sending = true;
      let regex = /<img[^>]*>/g;
      let text = this.interpretation.replaceAll(regex, "");
      let data = {
        templateHTML: text,
        name: this.modelDialog.nameTemplate,
        type: this.modelDialog.typeTemplate,
        // idHumanResource: this.$utilFront.getIdHumanResource(),s
        idModality: this.model.idModality,
      };
      TemplateDialogService.add(data)
        .then((res) => {
          let { data, status, statusText } = res;
          this.modelDialog.nameTemplate = "";
          this.modelDialog.typeTemplate = null;
          this.$utilFront.notifications(
            "Plantilla registrada correctamente.",
            "SUCCESS"
          );
          this.listAllTemplates();
          this.dialog = false;
          this.closeSliderSaveTemp = true;

        })
        .catch(this.catchError)
        .finally(() => {
          this.closeSliderSaveTemp = false;
          this.sending = false;
        });
    },
    changeTemplateInterpretation(eventtl) {
      if (eventtl != null) {
        let setTemplate = eventtl.templateHTML;
        setTemplate = setTemplate
          .replaceAll("<div>", "<p>")
          .replaceAll("</div>", "</p>");
        this.interpretation = setTemplate;
      } else {
        this.interpretation = "";
      }
    },
    isPDF() {
      return (
        this.model.acronymModality == "ECG" ||
        this.model.acronymModality == "DXA"
      );
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item.idStudy,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    downloadZIP(item) {
      this.sending = true;
      let data = { idStudy: item.idStudy };
      DownloadZipRequest.downloadImagesDCM(data)
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/zip",
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.idStudy + ".zip");
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    viewerOsirix(item) {
      this.sending = true;
      let data = {idStudy: item.idStudy};
      ConfigurationService.findConfigurationOsirixPath(data).then((res) => {
          window.open(res.data, "_blank").focus();
        }).catch((error)=> {
          UtilFront.errorhttp(error);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    downloadInterpretation1() {
      this.sending = true;
      let data = {
        idInterpretation: null,
        interpretationText: this.interpretation,
        idStudy: this.model.idStudy,
        fileName: "Interpretacion",
        idBirads: this?.modelDialog?.birads?.idBirads,
      };
      ReportPDFRequest.downloadInterpretation(data);
      this.sending = false;
    },
    openDialog(typeDialog) {
      this.typeDialog = typeDialog;
      this.dialog = true;
    },
    downloadInterpretation() {
      this.sending = true;
      let data = {
        idInterpretation: null,
        interpretationText: this.interpretation,
        idStudy: this.model.idStudy,
        fileName: "Interpretacion",
        idBirads: this?.modelDialog?.birads?.idBirads,
      };
      ReportPDFRequest.downloadInterpretation1(data).then((res) => {
        if (res.status == 200 && res.data.type != "application/json") {
          this.$utilFront.openPDF(res.data);
        } else {
          this.$utilFront.displayErrorPdf(res.data);
        }
      });
      this.sending = false;
    },
    async openPDF(file) {
      let w = window.open("about:blank");
      setTimeout(function () {
        w?.document.write(`
            <!DOCTYPE html>
              <head>
              <title>Informe</title>
              </head>
              <body>
              <img src="${file.url}" width="70%">
              </body>
            </html>`);
      }, 0);
    },
    addImages() {
      let imagetoupload = this.imagesToAdd;
      this.imagesToAdd = [];
      if (this.flag == 0) {
        this.listaddedImages = imagetoupload;
        let tableHTML = `<p style='display: flex; flex-wrap: wrap; align-items: center; justify-content: center;'>`;
        for (let i in this.listaddedImages) {
          const element = this.listaddedImages[i];
          let imageHTML = `<img src='${element.url}' style='width: 250px; margin:10px'/>`;
          tableHTML += `${imageHTML}`;
        }
        tableHTML += `</p>`;
        let interpretationHTML = this.interpretation;
        interpretationHTML += tableHTML;
        this.interpretation = interpretationHTML;
        this.flag = 1;
      } else if (this.flag == 1) {
        let tableHTML = `<p style='display: flex; flex-wrap: wrap; align-items: center; justify-content: center;'>`;
        for (let i in imagetoupload) {
          const element = imagetoupload[i];
          let imageHTML = `<img src='${element.url}' style='width: 250px; margin:10px'/>`;
          tableHTML += `${imageHTML}`;
        }
        tableHTML += `</p>`;
        let interpretationHTML = this.interpretation;
        interpretationHTML += tableHTML;
        this.interpretation = interpretationHTML;
      }
      this.dialogImages = false;
    },
  },
};
</script>

<style></style>
